import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { CgtTransaction } from '../../Models/Domains/Transactions/Investments/CgtTransaction';
import { ServiceValidationError } from '../../Core/DataTypes/ServiceValidation/ServiceValidationError';

declare var IS_RUNNING_IN_APP_POOL;

export class CgtTransactionClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(transId: number): Promise<CgtTransaction, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Transaction/CgtTransaction/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { transId: transId }

    return AjaxWrapper.get<CgtTransaction, any>(url, data);
  }
  public post(cgtTransaction: CgtTransaction): Promise<Array<ServiceValidationError>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Transaction/CgtTransaction/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { cgtTransaction: cgtTransaction }

    return AjaxWrapper.post<Array<ServiceValidationError>, any>(url, data);
  }
}

